import React, { useEffect, useId, useRef } from 'react';
import { createPortal } from 'react-dom';

/** Portal escapes glass containment. Native dialog provides focus trapping and inert background. */
export default function Sheet({ title, onClose, children, busy = false }: {
  title: string; onClose: () => void; children: React.ReactNode; busy?: boolean;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  const titleId = useId();
  useEffect(() => {
    const previous = document.activeElement as HTMLElement | null;
    const dialog = ref.current;
    dialog?.showModal?.();
    return () => { dialog?.close?.(); previous?.focus(); };
  }, [title]);
  return createPortal(<dialog ref={ref} className="cs-sheet" aria-labelledby={titleId}
    onCancel={e => { e.preventDefault(); if (!busy) onClose(); }}>
    <header className="cs-sheet__header"><h2 id={titleId}>{title}</h2>
      <button type="button" disabled={busy} onClick={onClose} aria-label={`Close ${title}`}>Close</button></header>
    <div className="cs-sheet__body">{children}</div>
  </dialog>, document.body);
}
